import { QuizQuestion } from '../quizEngine';

// Bitcoin: 100 questions (30 easy, 40 average, 30 very hard).
export const bitcoinQuestions: QuizQuestion[] = [
    // --- EASY (30) ---
    {
        id: 1,
        difficulty: 'easy',
        question: 'What is the maximum number of bitcoin that will ever exist?',
        choices: { a: '21 million', b: '100 million', c: '1 billion', d: 'unlimited' },
        answer: 'a',
        explanation: 'The supply asymptotically approaches 21 million BTC (slightly under, due to rounding).',
    },
    {
        id: 2,
        difficulty: 'easy',
        question: 'The smallest unit of bitcoin is the:',
        choices: { a: 'wei', b: 'satoshi', c: 'bit', d: 'finney' },
        answer: 'b',
        explanation: 'One BTC = 100,000,000 satoshis. A "bit" is a colloquial name for 100 sats; wei and finney are Ether units.',
    },
    {
        id: 3,
        difficulty: 'easy',
        question: "Bitcoin's consensus mechanism is:",
        choices: { a: 'Proof of Work', b: 'Proof of Stake', c: 'Proof of History', d: 'Delegated Proof of Stake' },
        answer: 'a',
        explanation: 'Miners expend energy hashing block headers to extend the chain.',
    },
    {
        id: 4,
        difficulty: 'easy',
        question: 'New bitcoins are created via the:',
        choices: {
            a: 'coinbase transaction in each new block',
            b: 'scheduled airdrop to full-node operators',
            c: 'developer fund released at each halving',
            d: 'staking rewards paid to long-term holders',
        },
        answer: 'a',
        explanation: 'The first transaction in a block pays the miner the subsidy plus fees.',
    },
    {
        id: 5,
        difficulty: 'easy',
        question: 'The block subsidy halves approximately every:',
        choices: { a: '210,000 blocks (~4 years)', b: '2016 blocks (~2 weeks)', c: '52,560 blocks (~1 year)', d: '100,000 blocks (~2 years)' },
        answer: 'a',
        explanation: 'Started at 50 BTC; halves at every 210,000-block interval.',
    },
    {
        id: 6,
        difficulty: 'easy',
        question: 'The target average time between Bitcoin blocks is:',
        choices: { a: '~10 minutes', b: '~12 seconds', c: '~1 hour', d: '~30 seconds' },
        answer: 'a',
        explanation: 'Difficulty retargets to keep the average near 10 minutes.',
    },
    {
        id: 7,
        difficulty: 'easy',
        question: 'Difficulty is adjusted every:',
        choices: { a: '2016 blocks (~2 weeks)', b: 'block (~10 minutes)', c: '210,000 blocks (~4 years)', d: '144 blocks (~1 day)' },
        answer: 'a',
        explanation: 'Each 2016-block epoch, the target is rescaled based on how long the epoch took. 210,000 blocks is the halving interval.',
    },
    {
        id: 8,
        difficulty: 'easy',
        question: "Bitcoin's ledger tracks:",
        choices: {
            a: 'unspent transaction outputs (UTXOs)',
            b: 'account balances in a global state trie',
            c: 'signed IOUs between pairs of users',
            d: 'per-address balances updated each block',
        },
        answer: 'a',
        explanation: 'A wallet\'s "balance" is the sum of UTXOs it can spend; there are no accounts in consensus.',
    },
    {
        id: 9,
        difficulty: 'easy',
        question: 'A transaction input spends:',
        choices: {
            a: 'a previous transaction output (a UTXO)',
            b: "a portion of the sender's account balance",
            c: 'fees left unclaimed in an earlier block',
            d: 'coins held in escrow by the mempool',
        },
        answer: 'a',
        explanation: 'Each input references a prior output by txid + index and provides a satisfying script.',
    },
    {
        id: 10,
        difficulty: 'easy',
        question: 'The hash function used for Bitcoin proof-of-work mining is:',
        choices: { a: 'double SHA-256', b: 'Keccak-256', c: 'Scrypt', d: 'Blake2b' },
        answer: 'a',
        explanation: 'Miners compute SHA-256(SHA-256(block header)) and compare to the target.',
    },
    {
        id: 11,
        difficulty: 'easy',
        question: 'Who authored the 2008 Bitcoin whitepaper?',
        choices: { a: 'Satoshi Nakamoto', b: 'Vitalik Buterin', c: 'Hal Finney', d: 'Nick Szabo' },
        answer: 'a',
        explanation: '"Bitcoin: A Peer-to-Peer Electronic Cash System" was published under the name Satoshi Nakamoto.',
    },
    {
        id: 12,
        difficulty: 'easy',
        question: 'An address starting with `bc1q` is:',
        choices: {
            a: 'a native SegWit (bech32) v0 address',
            b: 'a legacy P2PKH (base58) address',
            c: 'a Taproot (bech32m) v1 address',
            d: 'a P2SH-wrapped SegWit address',
        },
        answer: 'a',
        explanation: '`bc1q` is bech32 SegWit v0; `bc1p` is bech32m Taproot (v1). Legacy addresses start with `1`, P2SH with `3`.',
    },
    {
        id: 13,
        difficulty: 'easy',
        question: 'Bitcoin Script is:',
        choices: {
            a: 'a stack-based language with no loops',
            b: 'a restricted dialect of JavaScript',
            c: 'a register-based, Turing-complete bytecode',
            d: 'a WASM subset run in a sandbox',
        },
        answer: 'a',
        explanation: 'Bounded execution keeps validation cheap and predictable for all nodes.',
    },
    {
        id: 14,
        difficulty: 'easy',
        question: 'The most common legacy locking-script pattern is:',
        choices: {
            a: 'Pay-to-Public-Key-Hash (P2PKH)',
            b: 'Pay-to-Taproot (P2TR)',
            c: 'Pay-to-Witness-Script-Hash (P2WSH)',
            d: 'Pay-to-Contract (P2C)',
        },
        answer: 'a',
        explanation: 'P2PKH locks coins to the hash of a public key. P2WSH and P2TR are SegWit-era output types.',
    },
    {
        id: 15,
        difficulty: 'easy',
        question: 'SegWit (2017) primarily:',
        choices: {
            a: 'moved signatures into a separate witness, fixing malleability',
            b: 'raised the legacy block size limit from 1 MB to 2 MB',
            c: 'added Schnorr signatures and Taproot script trees to every output',
            d: 'introduced relative timelocks for payment channels',
        },
        answer: 'a',
        explanation: 'Segregating the witness fixed third-party transaction malleability and enabled the block-weight model. Schnorr came with Taproot; relative timelocks (CSV) in 2016.',
    },
    {
        id: 16,
        difficulty: 'easy',
        question: 'After SegWit, the block limit is expressed as:',
        choices: {
            a: '4 million weight units',
            b: 'a flat 2 MB of serialized data',
            c: '8 million weight units',
            d: '1 MB base plus 1 MB of witness data',
        },
        answer: 'a',
        explanation: 'Weight = 4 * base bytes + witness bytes; the cap is 4,000,000 WU (~4 MB max, ~1 MB base).',
    },
    {
        id: 17,
        difficulty: 'easy',
        question: 'A coinbase output cannot be spent until:',
        choices: { a: '100 confirmations', b: '6 confirmations', c: '2016 confirmations', d: '144 confirmations' },
        answer: 'a',
        explanation: 'The 100-block maturity limits damage from short reorgs of freshly mined coins.',
    },
    {
        id: 18,
        difficulty: 'easy',
        question: 'Blocks are chained together because each block header contains:',
        choices: {
            a: 'the hash of the previous block header',
            b: "a signature from the previous block's miner",
            c: 'the Merkle root of the previous block',
            d: 'a hash of the UTXO set after the prior block',
        },
        answer: 'a',
        explanation: 'Changing an old block would change its hash, breaking every subsequent link.',
    },
    {
        id: 19,
        difficulty: 'easy',
        question: 'A "confirmation" count means:',
        choices: {
            a: 'the depth of its block: that block plus every block on top',
            b: 'how many nodes have validated and relayed the transaction',
            c: 'how many miners have signed off on its block',
            d: 'how many mempools have accepted it for inclusion',
        },
        answer: 'a',
        explanation: 'One confirmation = included in a block; each block mined on top adds one. More confirmations = exponentially more work to reverse it.',
    },
    {
        id: 20,
        difficulty: 'easy',
        question: '`OP_RETURN` is used to:',
        choices: {
            a: 'embed a little arbitrary data in an unspendable output',
            b: "return a failed transaction's coins to the sender",
            c: 'mark an output as change returning to the sender',
            d: 'end script execution early and mark the input valid',
        },
        answer: 'a',
        explanation: 'An `OP_RETURN` output can never be spent (the opcode fails the script), so it is not kept in the UTXO set.',
    },
    {
        id: 21,
        difficulty: 'easy',
        question: 'The fee paid for a Bitcoin transaction is:',
        choices: {
            a: 'total input value minus total output value',
            b: 'a fixed amount per byte set by the protocol',
            c: 'an explicit fee field chosen by the sender',
            d: 'a percentage of the amount being sent',
        },
        answer: 'a',
        explanation: 'There is no fee field: whatever is not assigned to an output is claimable by the miner as fee.',
    },
    {
        id: 22,
        difficulty: 'easy',
        question: 'Fee rates are usually quoted in:',
        choices: {
            a: 'satoshis per virtual byte (sat/vB)',
            b: 'satoshis per signature operation',
            c: 'satoshis per input and output spent',
            d: 'gwei per unit of execution gas',
        },
        answer: 'a',
        explanation: 'Miners prioritize by fee density (sat/vB), not absolute fee.',
    },
    {
        id: 23,
        difficulty: 'easy',
        question: 'A BIP32 hierarchical-deterministic (HD) wallet lets you:',
        choices: {
            a: 'derive many keys deterministically from a single seed',
            b: 'split one private key into shares held by several devices',
            c: 'rotate to a fresh seed automatically after each payment',
            d: 'encrypt a private key with a password for safe backup',
        },
        answer: 'a',
        explanation: 'One backup of the seed recovers the entire tree of addresses. Key splitting is Shamir-style secret sharing; password encryption is BIP38.',
    },
    {
        id: 24,
        difficulty: 'easy',
        question: 'A BIP39 mnemonic is:',
        choices: {
            a: 'a human-readable seed phrase, typically 12 or 24 words',
            b: 'a password that encrypts an existing private key',
            c: 'a list of words that encodes a single receiving address',
            d: 'a checksum format for typing addresses without errors',
        },
        answer: 'a',
        explanation: 'The words encode entropy plus a checksum and derive the wallet seed.',
    },
    {
        id: 25,
        difficulty: 'easy',
        question: 'The Taproot upgrade (2021) introduced:',
        choices: {
            a: 'Schnorr signatures and Pay-to-Taproot (P2TR) outputs',
            b: 'segregated witness and a block weight limit',
            c: 'relative timelocks and the CSV opcode',
            d: 'confidential transaction amounts using Pedersen commitments',
        },
        answer: 'a',
        explanation: 'Taproot (BIPs 340/341/342) brought Schnorr sigs, key/script path spends, and MAST.',
    },
    {
        id: 26,
        difficulty: 'easy',
        question: 'The `nLockTime` field of a transaction can make it:',
        choices: {
            a: 'invalid until a certain block height or timestamp',
            b: 'expire if not mined before a certain height',
            c: 'unspendable by its recipient until a set height',
            d: 'replaceable by a higher-fee version until mined',
        },
        answer: 'a',
        explanation: "It sets an absolute earliest time the transaction itself may be mined. Locking an output is CLTV's job; Bitcoin transactions never expire.",
    },
    {
        id: 27,
        difficulty: 'easy',
        question: 'Replace-by-Fee (RBF) lets a sender:',
        choices: {
            a: 'rebroadcast an unconfirmed transaction with a higher fee',
            b: 'cancel a transaction even after it has one confirmation',
            c: 'lower the fee of a stuck transaction to save money',
            d: 'have the recipient pay the fee by spending the output',
        },
        answer: 'a',
        explanation: 'BIP125 signals replaceability so nodes accept the higher-fee version. The recipient-pays variant is CPFP.',
    },
    {
        id: 28,
        difficulty: 'easy',
        question: 'A given UTXO can be spent:',
        choices: {
            a: 'exactly once, consumed in full, with change as a new output',
            b: 'partially, leaving a smaller UTXO behind at the same outpoint',
            c: 'repeatedly, until its whole value has been sent',
            d: 'once per block, until its value drops below dust',
        },
        answer: 'a',
        explanation: 'You spend the whole UTXO and send yourself change as a separate output.',
    },
    {
        id: 29,
        difficulty: 'easy',
        question: 'The Lightning Network is:',
        choices: {
            a: 'a layer-2 network of payment channels for off-chain payments',
            b: 'a federated sidechain with faster blocks, pegged 1:1 to bitcoin',
            c: 'a relay network that propagates new blocks faster',
            d: 'a soft fork that cut block time to about one minute',
        },
        answer: 'a',
        explanation: 'Channels settle on-chain only at open/close; payments in between are off-chain. A pegged sidechain is something like Liquid.',
    },
    {
        id: 30,
        difficulty: 'easy',
        question: 'Running your own full node lets you:',
        choices: {
            a: 'validate every consensus rule yourself instead of trusting others',
            b: 'earn a small share of the fees on every transaction you relay to miners',
            c: 'get your own transactions confirmed ahead of the mempool',
            d: 'mine blocks without needing specialized hardware',
        },
        answer: 'a',
        explanation: 'A full node checks every rule (no inflation, no double-spends, valid scripts) for itself. Relaying earns nothing.',
    },

    // --- AVERAGE (40) ---
    {
        id: 31,
        difficulty: 'medium',
        question: 'A standard P2PKH locking script is:',
        choices: {
            a: 'OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG',
            b: 'OP_HASH160 <scriptHash> OP_EQUAL',
            c: 'OP_DUP OP_HASH160 <pubKey> OP_EQUALVERIFY OP_CHECKSIG',
            d: 'OP_DUP OP_HASH256 <pubKeyHash> OP_EQUAL OP_CHECKSIGVERIFY',
        },
        answer: 'a',
        explanation: 'The spender supplies a signature and public key that hash (HASH160) to `pubKeyHash`. `OP_HASH160 <scriptHash> OP_EQUAL` is P2SH.',
    },
    {
        id: 32,
        difficulty: 'medium',
        question: "To spend a P2PKH output, the spending input's scriptSig pushes:",
        choices: { a: '<signature> <publicKey>', b: '<publicKey> <signature>', c: '<signature> <pubKeyHash>', d: '<publicKey> <redeemScript>' },
        answer: 'a',
        explanation: 'Signature first, then the public key, so the key is on top for `OP_DUP OP_HASH160`. For P2WPKH the same two items live in the witness.',
    },
    {
        id: 33,
        difficulty: 'medium',
        question: 'Pay-to-Script-Hash (P2SH, BIP16) locks funds to:',
        choices: {
            a: 'the hash of a redeem script the spender reveals later',
            b: 'the hash of a public key the spender reveals later',
            c: 'a Merkle root of alternative spending scripts',
            d: 'a script stored on-chain in full inside the output',
        },
        answer: 'a',
        explanation: 'It moves the burden of the (possibly complex) script to the spender. Key hashes are P2PKH; script trees are Taproot.',
    },
    {
        id: 34,
        difficulty: 'medium',
        question: 'A "2-of-3 multisig" means:',
        choices: {
            a: 'any 2 of 3 specified keys must sign to spend',
            b: '2 signatures now and a 3rd after a timelock',
            c: 'any 2 of 3 outputs may be spent by one key',
            d: '2 keys sign in order, with the 3rd as tie-break',
        },
        answer: 'a',
        explanation: 'Threshold signatures are common for shared custody and escrow.',
    },
    {
        id: 35,
        difficulty: 'medium',
        question: '`OP_CHECKMULTISIG` has a famous:',
        choices: {
            a: 'off-by-one bug that pops an extra dummy stack element',
            b: 'bug that lets one key satisfy several signature slots',
            c: 'integer overflow when counting more than 16 signatures',
            d: 'bug that ignores the order in which signatures appear',
        },
        answer: 'a',
        explanation: 'Convention is to push `OP_0` as the dummy; the bug is kept to avoid a hard fork. Signature order does matter.',
    },
    {
        id: 36,
        difficulty: 'medium',
        question: 'SegWit v0 output types are:',
        choices: {
            a: 'P2WPKH (20-byte program) and P2WSH (32-byte program)',
            b: 'P2WPKH (32-byte program) and P2WSH (20-byte program)',
            c: 'P2TR (32-byte program) and P2WSH (20-byte program)',
            d: 'P2SH (20-byte hash) and P2PKH (20-byte hash)',
        },
        answer: 'a',
        explanation: 'The witness program length distinguishes key-hash (HASH160, 20 bytes) from script-hash (SHA-256, 32 bytes). P2TR is v1.',
    },
    {
        id: 37,
        difficulty: 'medium',
        question: '"Transaction malleability" was the problem where:',
        choices: {
            a: 'a third party could alter a signature, changing the txid',
            b: 'a third party could change the amount without the key',
            c: 'a miner could reorder inputs without breaking signatures',
            d: 'a sender could double-spend by rebroadcasting quickly',
        },
        answer: 'a',
        explanation: 'Changed txids broke chains of unconfirmed transactions; SegWit fixed it.',
    },
    {
        id: 38,
        difficulty: 'medium',
        question: 'The SegWit "witness discount" means witness bytes count as:',
        choices: {
            a: '1 weight unit per byte, vs 4 for non-witness bytes',
            b: '4 weight units per byte, vs 1 for non-witness bytes',
            c: '2 weight units per byte, vs 4 for non-witness bytes',
            d: '0 weight units, since witness data can be pruned',
        },
        answer: 'a',
        explanation: 'This makes spending SegWit outputs cheaper in fee terms.',
    },
    {
        id: 39,
        difficulty: 'medium',
        question: 'BIP68 relative timelocks are encoded in:',
        choices: {
            a: "the input's `nSequence` field",
            b: "the transaction's `nLockTime` field",
            c: "the block header's `nTime` field",
            d: 'a CLTV push inside the locking script',
        },
        answer: 'a',
        explanation: '`nSequence` encodes a relative delay (blocks or 512-second units since the funding output was mined); a disable bit turns it off.',
    },
    {
        id: 40,
        difficulty: 'medium',
        question: '`OP_CHECKLOCKTIMEVERIFY` (CLTV, BIP65) enforces:',
        choices: {
            a: "an absolute timelock, checked against the spending tx's nLockTime",
            b: "a relative timelock, checked against the input's nSequence",
            c: "an absolute timelock, checked against the current block's time",
            d: 'an expiry after which the output can no longer be spent',
        },
        answer: 'a',
        explanation: 'Scripts cannot see the block, so CLTV compares against `nLockTime`, which consensus in turn checks against the chain. Relative locks are CSV.',
    },
    {
        id: 41,
        difficulty: 'medium',
        question: '`OP_CHECKSEQUENCEVERIFY` (CSV, BIP112) enforces:',
        choices: {
            a: "a relative timelock via the spending input's nSequence",
            b: "an absolute timelock via the transaction's nLockTime",
            c: "a relative timelock measured by the header's nTime",
            d: "that the input's sequence number is final (0xFFFFFFFF)",
        },
        answer: 'a',
        explanation: 'CSV is the script opcode that reads the BIP68 relative-timelock value.',
    },
    {
        id: 42,
        difficulty: 'medium',
        question: 'The Merkle root in a block header commits to:',
        choices: {
            a: 'all transactions in that block',
            b: 'the full UTXO set after the block',
            c: 'the headers of the previous 2016 blocks',
            d: 'every transaction in the mempool',
        },
        answer: 'a',
        explanation: 'Any change to a transaction changes the Merkle root, and thus the header hash.',
    },
    {
        id: 43,
        difficulty: 'medium',
        question: 'A Simplified Payment Verification (SPV) client verifies a payment by:',
        choices: {
            a: 'checking a Merkle branch to a header in the most-work chain',
            b: 'asking several random full nodes whether it was confirmed in a block',
            c: 'downloading and validating each block that pays it',
            d: "checking the tx's signatures against the UTXO set",
        },
        answer: 'a',
        explanation: 'SPV trusts that the most-work header chain contains only valid blocks.',
    },
    {
        id: 44,
        difficulty: 'medium',
        question: 'A Bitcoin block header is:',
        choices: { a: '80 bytes', b: '64 bytes', c: '32 bytes', d: '256 bytes' },
        answer: 'a',
        explanation: 'Version, previous hash, Merkle root, time, bits and nonce total 80 bytes. Miners iterate the nonce (and other fields) searching for a valid hash.',
    },
    {
        id: 45,
        difficulty: 'medium',
        question: 'The `bits` / `nBits` field in the header encodes:',
        choices: {
            a: 'the current proof-of-work target, in compact form',
            b: 'the number of transactions in the block, bit-packed',
            c: 'the soft-fork versionbits the miner is signaling',
            d: "the block's total weight in compact floating-point form",
        },
        answer: 'a',
        explanation: 'The header hash (as a number) must be at or below the target that `nBits` expands to. Versionbits signaling lives in `nVersion`.',
    },
    {
        id: 46,
        difficulty: 'medium',
        question: 'If a 2016-block retarget period was mined faster than two weeks, difficulty:',
        choices: { a: 'increases', b: 'decreases', c: 'stays the same', d: 'resets to genesis difficulty' },
        answer: 'a',
        explanation: 'Faster blocks mean more hashrate, so difficulty rises to restore the 10-minute average.',
    },
    {
        id: 47,
        difficulty: 'medium',
        question: 'A 51% attacker can:',
        choices: {
            a: 'reorg recent blocks to double-spend or censor transactions',
            b: 'spend coins from any address without its private key',
            c: 'raise the block subsidy above the halving schedule',
            d: 'rewrite deep history cheaply, since old blocks need no work',
        },
        answer: 'a',
        explanation: 'Majority hashrate buys reorg power over the tip, not the ability to forge signatures or break consensus rules.',
    },
    {
        id: 48,
        difficulty: 'medium',
        question: 'The "longest chain" rule actually selects:',
        choices: {
            a: 'the chain with the most cumulative proof-of-work',
            b: 'the chain with the most blocks, regardless of work',
            c: 'the chain whose tip has the lowest block hash',
            d: 'the chain the majority of nodes saw first',
        },
        answer: 'a',
        explanation: 'Work, not block count, is decisive when difficulty differs between branches.',
    },
    {
        id: 49,
        difficulty: 'medium',
        question: 'A "dust" output is:',
        choices: {
            a: 'an output worth less than the fee needed to spend it',
            b: 'any output below 0.001 BTC, rejected by consensus',
            c: 'an output left unspent for more than a year',
            d: 'the leftover change output of a transaction',
        },
        answer: 'a',
        explanation: 'Nodes have a dust relay threshold (policy, not consensus) below which outputs are considered uneconomical.',
    },
    {
        id: 50,
        difficulty: 'medium',
        question: 'BIP44 defines:',
        choices: {
            a: 'a standard HD derivation path, m/44\'/coin\'/account\'/change/index',
            b: 'a standard mnemonic format for encoding the wallet seed as words',
            c: 'a standard format for passing partially signed transactions',
            d: 'a standard checksummed address format for SegWit outputs',
        },
        answer: 'a',
        explanation: 'It structures multi-coin, multi-account HD wallets. Mnemonics are BIP39, PSBT is BIP174, bech32 is BIP173.',
    },
    {
        id: 51,
        difficulty: 'medium',
        question: 'Hardened derivation (the apostrophe, e.g. m/44\') in BIP32:',
        choices: {
            a: "means child keys can't be derived from the parent xpub alone",
            b: 'makes the derived keys resistant to quantum attacks',
            c: 'marks the branch as used for change addresses only',
            d: 'uses a longer 512-bit chain code for extra entropy in child keys',
        },
        answer: 'a',
        explanation: 'Hardened children need the parent private key, so a leaked xpub plus one child private key cannot be used to recover the parent private key.',
    },
    {
        id: 52,
        difficulty: 'medium',
        question: 'Schnorr signatures (BIP340) enable:',
        choices: {
            a: 'key and signature aggregation, e.g. MuSig multisig',
            b: 'hiding transaction amounts from outside observers',
            c: 'signatures that stay valid if the tx is modified',
            d: "verification without knowing the signer's public key",
        },
        answer: 'a',
        explanation: 'Their linearity lets multiple signers produce one aggregate signature.',
    },
    {
        id: 53,
        difficulty: 'medium',
        question: 'A Pay-to-Taproot (P2TR) output can be spent by:',
        choices: {
            a: 'a key path (one signature) or a script path (one revealed leaf)',
            b: 'a key path only; any scripts need a separate P2WSH output alongside',
            c: 'a script path only, revealing every leaf in the tree',
            d: 'a key path plus every script leaf, verified together',
        },
        answer: 'a',
        explanation: 'Taproot combines a tweaked public key with an optional MAST of alternative scripts.',
    },
    {
        id: 54,
        difficulty: 'medium',
        question: 'The privacy benefit of a Taproot key-path spend is that:',
        choices: {
            a: 'a cooperative multisig spend looks like a single-sig spend',
            b: 'the amounts moved are hidden behind Pedersen commitments on-chain',
            c: "the sender's address is replaced by a one-time key",
            d: 'the fee is paid privately out of band to the miner',
        },
        answer: 'a',
        explanation: 'Only if a script-path spend is used does the alternative script become visible. Amounts stay public.',
    },
    {
        id: 55,
        difficulty: 'medium',
        question: 'A PSBT (BIP174) is a format for:',
        choices: {
            a: 'passing a partially signed transaction between signers',
            b: 'compressing transactions for relay between nodes',
            c: 'backing up Lightning channel states off-site',
            d: 'encoding a payment request with amount and expiry',
        },
        answer: 'a',
        explanation: 'PSBT standardizes multi-party signing workflows, e.g. between a coordinator and a hardware wallet.',
    },
    {
        id: 56,
        difficulty: 'medium',
        question: 'The sighash flags (SIGHASH_ALL, NONE, SINGLE, ANYONECANPAY) control:',
        choices: {
            a: 'which parts of the transaction a signature commits to',
            b: 'how the fee is split between inputs and outputs',
            c: 'which algorithm (ECDSA or Schnorr) signs the input',
            d: 'which nodes are allowed to relay the transaction',
        },
        answer: 'a',
        explanation: 'SIGHASH_ALL (the default) signs all inputs and outputs.',
    },
    {
        id: 57,
        difficulty: 'medium',
        question: '`SIGHASH_ANYONECANPAY` allows:',
        choices: {
            a: 'others to add inputs later without breaking your signature',
            b: 'anyone to spend the output with an empty signature',
            c: 'others to change the outputs without breaking your signature',
            d: 'the fee to be paid by whoever broadcasts the transaction',
        },
        answer: 'a',
        explanation: 'Useful for crowdfunding-style transactions where contributors add inputs. Leaving outputs unsigned is `SIGHASH_NONE`.',
    },
    {
        id: 58,
        difficulty: 'medium',
        question: 'A transaction signals RBF (BIP125) by:',
        choices: {
            a: "setting an input's nSequence below 0xFFFFFFFE",
            b: 'setting its nLockTime to a height in the past',
            c: 'setting the version field to 2 or higher',
            d: 'adding an OP_RETURN output with an RBF flag',
        },
        answer: 'a',
        explanation: 'A low `nSequence` on any input marks the transaction as opt-in replaceable (many nodes now apply full-RBF regardless).',
    },
    {
        id: 59,
        difficulty: 'medium',
        question: 'Child-Pays-For-Parent (CPFP) lets:',
        choices: {
            a: 'a receiver bump a stuck parent via a high-fee child',
            b: 'a sender replace a stuck parent with a higher fee',
            c: "the parent's fee be refunded once the child confirms",
            d: "the child pay the parent's fee in a later block",
        },
        answer: 'a',
        explanation: 'Miners consider the parent+child package fee rate together. Replacing the parent is RBF.',
    },
    {
        id: 60,
        difficulty: 'medium',
        question: 'The coinbase transaction has:',
        choices: {
            a: 'one input with a null previous-output reference',
            b: 'no inputs, only outputs paying the subsidy and fees',
            c: 'one input per transaction in the block, collecting fees',
            d: "an input signed by the miner's key to claim the reward",
        },
        answer: 'a',
        explanation: "Its single input's scriptSig is arbitrary data (including the block height, per BIP34).",
    },
    {
        id: 61,
        difficulty: 'medium',
        question: 'The mempool is:',
        choices: {
            a: "a node's local set of valid, unconfirmed transactions",
            b: 'a global queue of transactions, identical on every node',
            c: 'the set of all unspent outputs on the chain',
            d: 'the pool of recent blocks awaiting enough confirmations',
        },
        answer: 'a',
        explanation: 'Mempools differ between nodes and are not part of consensus.',
    },
    {
        id: 62,
        difficulty: 'medium',
        question: 'A Bitcoin private key is:',
        choices: {
            a: 'a 256-bit number; the public key is a secp256k1 point',
            b: 'a 160-bit hash of the public key, kept secret',
            c: 'a 512-bit number; the public key is its SHA-256 hash',
            d: 'a 256-bit number; the public key is an ed25519 point',
        },
        answer: 'a',
        explanation: 'ECDSA (and now Schnorr) over secp256k1 underpins Bitcoin signatures.',
    },
    {
        id: 63,
        difficulty: 'medium',
        question: 'Compressed vs uncompressed public keys:',
        choices: {
            a: 'compressed is 33 bytes (x + parity); uncompressed is 65 (x and y)',
            b: 'compressed is 32 bytes (x only); uncompressed is 65 (x and y)',
            c: 'both give the same address; compression only saves space',
            d: 'compressed keys drop precision, so they are slightly weaker',
        },
        answer: 'a',
        explanation: 'Modern wallets use compressed keys to save space; the address differs from the uncompressed form. 32-byte x-only keys are a Taproot thing.',
    },
    {
        id: 64,
        difficulty: 'medium',
        question: "A transaction's `txid` is:",
        choices: {
            a: 'the double-SHA256 of the transaction, excluding witness data',
            b: 'the double-SHA256 of the transaction, including witness data',
            c: "the SHA-256 of the first input's signature and public key",
            d: 'the hash of the block it is in, plus its position index',
        },
        answer: 'a',
        explanation: 'Excluding the witness from the txid is exactly what fixes malleability. The hash including the witness is the `wtxid`.',
    },
    {
        id: 65,
        difficulty: 'medium',
        question: 'bech32 / bech32m address encoding provides:',
        choices: {
            a: 'strong typo detection and case-insensitive addresses',
            b: 'encryption that hides the address from observers',
            c: 'addresses that are always shorter than base58 ones',
            d: 'a built-in field for the requested payment amount',
        },
        answer: 'a',
        explanation: 'The BCH checksum catches common typos; Taproot uses the bech32m variant.',
    },
    {
        id: 66,
        difficulty: 'medium',
        question: 'Bitcoin stale ("orphan") blocks occur when:',
        choices: {
            a: 'two valid blocks appear at the same height and one loses',
            b: 'a block fails validation and is rejected by peers',
            c: 'a miner withholds a block until the next difficulty epoch',
            d: 'a block contains no transactions besides the coinbase',
        },
        answer: 'a',
        explanation: 'Nodes converge on whichever branch accumulates more work next.',
    },
    {
        id: 67,
        difficulty: 'medium',
        question: "The genesis block's coinbase output is:",
        choices: {
            a: 'unspendable, due to a quirk in how it was indexed',
            b: "spendable only by Satoshi's original public key",
            c: 'spendable by anyone, since it has no locking script',
            d: 'burned by design, using an OP_RETURN locking script',
        },
        answer: 'a',
        explanation: 'The 50 BTC genesis reward was never added to the UTXO database, so it cannot be spent. Its input carries "The Times 03/Jan/2009 Chancellor..." text.',
    },
    {
        id: 68,
        difficulty: 'medium',
        question: 'The `wtxid` (witness txid) differs from the `txid` in that it:',
        choices: {
            a: 'includes the witness; it is committed to in the coinbase',
            b: 'excludes the outputs, so it is stable across RBF',
            c: 'is the txid truncated to 20 bytes for use in addresses',
            d: 'includes the block hash, so it is unique per block',
        },
        answer: 'a',
        explanation: 'The coinbase carries a commitment to the Merkle root of wtxids so SegWit data is protected.',
    },
    {
        id: 69,
        difficulty: 'medium',
        question: 'Anti-fee-sniping in modern wallets sets `nLockTime` to roughly the current height so that:',
        choices: {
            a: "a miner reorging the tip can't move it into an earlier block",
            b: 'the transaction pays the lowest fee that still confirms',
            c: 'the transaction is guaranteed to confirm in the next block',
            d: "the change output can't be linked back to the sender",
        },
        answer: 'a',
        explanation: 'It reduces the incentive to reorg the chain tip to steal high-fee transactions.',
    },
    {
        id: 70,
        difficulty: 'medium',
        question: 'Bitcoin Script is deliberately not Turing-complete because:',
        choices: {
            a: 'bounded scripts keep validation cheap and predictable for all nodes',
            b: "loops can't be expressed in a stack-based language at all",
            c: 'Satoshi planned to add loops once blocks grew larger',
            d: 'Turing-complete scripts would never fit within the 10,000-byte script limit',
        },
        answer: 'a',
        explanation: 'With no loops, every script terminates in bounded steps, avoiding halting-problem DoS.',
    },

    // --- VERY HARD (30) ---
    {
        id: 71,
        difficulty: 'hard',
        question: "Why is Bitcoin's real maximum supply slightly UNDER 21,000,000 BTC?",
        choices: {
            a: 'the subsidy is integer satoshis halved by right-shift, so remainders are lost',
            b: 'the halving interval drifts as block times vary, which cuts total issuance early',
            c: 'fees are paid out of the subsidy, so each fee lowers the final cap',
            d: 'a 2010 soft fork reduced the per-block subsidy by one satoshi',
        },
        answer: 'a',
        explanation: 'The total lands near 20,999,999.9769 BTC because of integer rounding of the subsidy (halvings are by height, not time). Underclaimed coinbases and lost coins reduce it further.',
    },
    {
        id: 72,
        difficulty: 'hard',
        question: 'The "median time past" rule (BIP113) makes time-based locktimes compare against:',
        choices: {
            a: 'the median of the last 11 block timestamps',
            b: 'the timestamp of the block the transaction lands in',
            c: 'the wall-clock time of the validating node',
            d: 'the average timestamp of the current 2016-block epoch',
        },
        answer: 'a',
        explanation: "Before BIP113 the block's own (miner-chosen) timestamp was used; MTP is much harder for a miner to manipulate.",
    },
    {
        id: 73,
        difficulty: 'hard',
        question: 'The `OP_CHECKMULTISIG` dummy-element bug persists because:',
        choices: {
            a: 'removing it would be a hard fork, so wallets just push OP_0',
            b: 'the extra element carries the signature count the opcode reads',
            c: 'SegWit repurposes the dummy element to commit to witness data',
            d: 'it is needed to stay compatible with P2SH redeem scripts',
        },
        answer: 'a',
        explanation: "Consensus bugs are frozen in place: BIP147 (NULLDUMMY) only requires the dummy to be empty, and Tapscript's `OP_CHECKSIGADD` replaces multisig cleanly.",
    },
    {
        id: 74,
        difficulty: 'hard',
        question: 'BIP68 relative-timelock granularity in `nSequence`:',
        choices: {
            a: 'a type flag picks blocks or 512-second units; a disable flag turns it off',
            b: 'a type flag picks blocks or 1-second units; the value can span 32 bits',
            c: 'always in blocks, up to 65,535, with no time-based mode available',
            d: 'a type flag picks blocks or 600-second units matching block time',
        },
        answer: 'a',
        explanation: 'Only the low 16 bits are the value; specific high bits are the type and disable flags.',
    },
    {
        id: 75,
        difficulty: 'hard',
        question: 'A Taproot output key Q (internal key P, script-tree root m) is computed as:',
        choices: {
            a: 'Q = P + H(P || m)*G',
            b: 'Q = P + H(m)*G',
            c: 'Q = H(P || m)*G',
            d: 'Q = H(P || m)*P',
        },
        answer: 'a',
        explanation: 'The internal key is tweaked by a (tagged TapTweak) hash of itself and the script-tree root. A key-path spend signs with the tweaked private key, provably committing to the scripts.',
    },
    {
        id: 76,
        difficulty: 'hard',
        question: 'On a Taproot script-path spend, the witness reveals:',
        choices: {
            a: 'only the executed leaf, a Merkle proof and the internal key',
            b: 'every leaf script, so validators can check the whole tree',
            c: 'the executed leaf plus the tweaked private key as proof',
            d: 'only the executed leaf; the tree root is read from the UTXO',
        },
        answer: 'a',
        explanation: 'The control block carries the internal key and Merkle path. MAST keeps unused conditions private and reduces witness size.',
    },
    {
        id: 77,
        difficulty: 'hard',
        question: 'Why does a Taproot key-path spend not even reveal that a script tree exists?',
        choices: {
            a: 'the tweaked key looks like any key until a script path is used',
            b: 'the witness is encrypted so only the recipient can read it',
            c: 'bech32m addresses omit the version when a tree is present',
            d: 'nodes strip the script commitment from the UTXO once the output is spent',
        },
        answer: 'a',
        explanation: 'The tweak is indistinguishable from a random key offset. If no key path is wanted, best practice is a NUMS internal key.',
    },
    {
        id: 78,
        difficulty: 'hard',
        question: 'SegWit fixed malleability by:',
        choices: {
            a: 'excluding the witness from the data hashed for the txid',
            b: 'requiring deterministic RFC 6979 nonces for all signatures',
            c: 'making low-S signatures a consensus rule for all inputs',
            d: 'hashing the witness into the txid so changes are detected',
        },
        answer: 'a',
        explanation: 'Stable txids make chains of unconfirmed transactions (e.g. Lightning) safe to build. Low-S is only a relay policy for legacy inputs.',
    },
    {
        id: 79,
        difficulty: 'hard',
        question: 'The difficulty retarget is clamped to a maximum change per period of:',
        choices: { a: '4x up or 1/4x down', b: '2x up or 1/2x down', c: '10% either way', d: '8x up or 1/8x down' },
        answer: 'a',
        explanation: 'The clamp prevents extreme swings from timestamp manipulation or sudden hashrate changes.',
    },
    {
        id: 80,
        difficulty: 'hard',
        question: 'The "timewarp" attack exploits:',
        choices: {
            a: 'a retarget that skips one interval, so boundary timestamps can be gamed',
            b: 'nodes accepting any timestamp, letting miners backdate every block',
            c: 'lagging nodes that still accept stale blocks at lower difficulty',
            d: 'the 2-hour future-time limit, letting miners skip a halving',
        },
        answer: 'a',
        explanation: "The retarget measures 2015 intervals per 2016-block window and epochs don't overlap, so a majority miner can manipulate boundary timestamps to lower difficulty. Proposed soft forks (e.g. consensus cleanup) close it.",
    },
    {
        id: 81,
        difficulty: 'hard',
        question: '"Selfish mining" is the strategy where a miner with a large minority of hashrate:',
        choices: {
            a: 'withholds found blocks and releases them to orphan honest ones',
            b: "mines empty blocks so they propagate faster than rivals'",
            c: 'skips validating new blocks so it can start mining the next one sooner',
            d: 'double-spends its own coinbase before it matures',
        },
        answer: 'a',
        explanation: 'Analyses put the profitability threshold around 25-33% of hashrate. Skipping validation is "SPV mining", a different (risky) shortcut.',
    },
    {
        id: 82,
        difficulty: 'hard',
        question: 'BIP125 "rule 3" for a valid RBF replacement requires that it:',
        choices: {
            a: 'pays at least the total fees of every transaction it evicts',
            b: 'pays at least double the fee of the transaction it replaces',
            c: 'pays a higher fee rate, even if its absolute fee is lower',
            d: 'spends all the same inputs as the original, with no new ones',
        },
        answer: 'a',
        explanation: "Rule 3 is about absolute fees: it must not decrease the total fees the network would collect (plus rule 4's relay-fee increment).",
    },
    {
        id: 83,
        difficulty: 'hard',
        question: 'Mempool ancestor/descendant limits (default ~25 transactions / ~101 kvB) exist because:',
        choices: {
            a: 'long unconfirmed chains make eviction and block building costly',
            b: 'consensus rejects blocks with longer chains of dependencies',
            c: 'they stop the same output being double-spent in the mempool',
            d: 'they cap how many transactions one address may send per block',
        },
        answer: 'a',
        explanation: 'These are policy (per-node) limits, not consensus rules. They also limit naive CPFP, which motivated package relay.',
    },
    {
        id: 84,
        difficulty: 'hard',
        question: 'Why can an SPV client NOT detect an invalid block that a miner includes (e.g. one that inflates the supply)?',
        choices: {
            a: 'SPV checks headers and Merkle proofs, not block validity',
            b: 'invalid blocks are filtered out by the mining pool first',
            c: "Merkle proofs don't cover the coinbase, where inflation lives",
            d: 'SPV clients only connect to one node, which could lie',
        },
        answer: 'a',
        explanation: 'It trusts that the most-work chain contains only valid blocks. That is the core security trade-off of light clients versus full nodes.',
    },
    {
        id: 85,
        difficulty: 'hard',
        question: 'BIP143 (the SegWit v0 signature digest) changed sighash computation by:',
        choices: {
            a: 'committing to input amounts and making hashing roughly linear',
            b: 'hashing only the signed input, to cut signature size',
            c: 'switching to Schnorr so signatures can be batch-verified',
            d: 'adding the block height so signatures expire after a reorg',
        },
        answer: 'a',
        explanation: 'Legacy sighash re-serialized the whole tx per input (O(n^2)); BIP143 uses precomputed midstates and closed a quadratic-hashing DoS.',
    },
    {
        id: 86,
        difficulty: 'hard',
        question: 'The legacy `SIGHASH_SINGLE` "bug" is that:',
        choices: {
            a: 'with no matching output, the signed digest is the constant 1',
            b: 'it commits to every output, not just the matching one',
            c: 'it lets anyone swap the input it signs for another',
            d: 'it fails verification whenever inputs outnumber outputs',
        },
        answer: 'a',
        explanation: 'If the input index has no corresponding output, the digest is 1 and verification still passes, so a signature over "1" can spend other coins with the same key. BIP143 fixed it for SegWit.',
    },
    {
        id: 87,
        difficulty: 'hard',
        question: 'The Schnorr linearity property is useful for MuSig2 because:',
        choices: {
            a: 'keys and signatures add, so n parties produce one key and one sig',
            b: 'it hides which subset of signers took part, like a ring signature',
            c: 'it removes the need for nonces, making signing a single round',
            d: 'signatures can be verified without the message being known',
        },
        answer: 'a',
        explanation: 'The aggregate looks like a single-sig. Naive key addition is vulnerable to rogue-key attacks, which MuSig addresses with key-aggregation coefficients; MuSig2 takes two rounds.',
    },
    {
        id: 88,
        difficulty: 'hard',
        question: 'A transaction is "final" (mineable now) if:',
        choices: {
            a: 'its nLockTime is satisfied, or every nSequence is 0xFFFFFFFF',
            b: 'its nLockTime is in the past and its version is at least 2',
            c: "any input's nSequence is 0xFFFFFFFF, whatever nLockTime says",
            d: 'it is one block past its nLockTime, per BIP113 median time',
        },
        answer: 'a',
        explanation: 'A max `nSequence` on ALL inputs disables locktime enforcement; a single final input is not enough.',
    },
    {
        id: 89,
        difficulty: 'hard',
        question: 'BIP34 requires the coinbase `scriptSig` to begin with:',
        choices: {
            a: 'the block height, so coinbase txids are unique',
            b: "the miner's public key, so the reward is claimable",
            c: 'the previous block hash, chaining coinbases together',
            d: "the witness commitment for the block's SegWit data",
        },
        answer: 'a',
        explanation: 'This closed the duplicate-coinbase-txid problem (see also BIP30). The witness commitment lives in a coinbase output.',
    },
    {
        id: 90,
        difficulty: 'hard',
        question: 'Why does simply raising the block size not linearly improve safe throughput?',
        choices: {
            a: 'larger blocks propagate slower, raising orphans and centralization',
            b: 'SHA-256 mining cost grows quadratically with block size',
            c: 'the Merkle tree depth is capped, which limits the transaction count per block',
            d: "signature checks can't be parallelized across a block",
        },
        answer: 'a',
        explanation: 'Orphan risk and node resource costs bound how large blocks can safely be. Miners only hash the 80-byte header.',
    },
    {
        id: 91,
        difficulty: 'hard',
        question: 'Taproot script-path k-of-n multisig is typically built with:',
        choices: {
            a: 'OP_CHECKSIGADD, accumulating valid signatures into a count',
            b: 'OP_CHECKMULTISIG, which Tapscript keeps for compatibility',
            c: 'OP_CHECKSIGVERIFY once, with the keys concatenated',
            d: 'OP_CHECKMULTISIGVERIFY with Schnorr keys instead of ECDSA',
        },
        answer: 'a',
        explanation: 'Tapscript disables `OP_CHECKMULTISIG(VERIFY)`; the count from `OP_CHECKSIGADD` is compared with `OP_NUMEQUAL` / `OP_GREATERTHANOREQUAL`.',
    },
    {
        id: 92,
        difficulty: 'hard',
        question: 'A deep chain reorganization is economically deterred because:',
        choices: {
            a: "it means redoing N blocks' work faster than the honest chain grows",
            b: 'nodes refuse any reorg deeper than 6 blocks by consensus',
            c: "old blocks are signed by validators and can't be replaced afterwards",
            d: 'miners who reorg lose their coinbase to a penalty rule',
        },
        answer: 'a',
        explanation: 'Finality in Bitcoin is probabilistic: the cost scales with depth and current hashrate.',
    },
    {
        id: 93,
        difficulty: 'hard',
        question: 'UTXO-set commitments / accumulators (e.g. Utreexo) aim to:',
        choices: {
            a: 'let nodes validate without storing the full UTXO set',
            b: 'hide the amounts and owners of unspent outputs from peers',
            c: 'let miners skip checking the scripts of old outputs',
            d: 'shrink blocks by referencing outputs by a short index',
        },
        answer: 'a',
        explanation: 'They compress the multi-GB UTXO set into a small accumulator, trading storage for per-input inclusion proofs.',
    },
    {
        id: 94,
        difficulty: 'hard',
        question: 'BIP30 (before BIP34) forbade:',
        choices: {
            a: 'a transaction whose txid matches a still-unspent one',
            b: 'two transactions spending the same output in one block',
            c: 'a coinbase paying more than the subsidy plus fees',
            d: 'spending a coinbase output before 100 confirmations',
        },
        answer: 'a',
        explanation: 'Two identical coinbase txids once occurred; BIP30 disallowed overwriting an unspent one, BIP34 prevented recurrence.',
    },
    {
        id: 95,
        difficulty: 'hard',
        question: 'Fee estimation is inherently unstable during congestion because:',
        choices: {
            a: 'block space is a blind auction, and estimates lag demand',
            b: 'miners publish fee schedules that change every hour',
            c: 'the protocol adjusts a minimum base fee after each block',
            d: 'fees are paid in a separate token whose price floats',
        },
        answer: 'a',
        explanation: 'Wallets estimate from recent blocks/mempool, which lags sudden demand shifts. RBF and CPFP exist because a broadcast fee can turn out to be wrong.',
    },
    {
        id: 96,
        difficulty: 'hard',
        question: 'In Bitcoin Script, values wider than 32 bits (e.g. locktimes) are handled with:',
        choices: {
            a: 'CScriptNum, 4 bytes normally but up to 5 for CLTV/CSV',
            b: 'native 256-bit unsigned integers, as in the EVM',
            c: "big-endian two's-complement integers of any length",
            d: 'fixed 64-bit unsigned integers for all arithmetic',
        },
        answer: 'a',
        explanation: 'Script numbers are little-endian, sign-magnitude, minimally encoded and range-limited to keep arithmetic bounded.',
    },
    {
        id: 97,
        difficulty: 'hard',
        question: 'Why do wallets prefer making the cooperative case of a contract a Taproot key-path spend?',
        choices: {
            a: 'key-path spends are smaller and look like ordinary payments',
            b: 'script-path spends are non-standard and not relayed by nodes',
            c: 'key-path spends skip signature checks, saving node CPU',
            d: 'script-path spends need every party online to sign',
        },
        answer: 'a',
        explanation: 'One 64-byte signature vs a revealed script plus control block. The uncooperative fallback lives in the script tree and is only used if cooperation fails.',
    },
    {
        id: 98,
        difficulty: 'hard',
        question: 'ECDSA signature "low-S" enforcement (BIP62 / policy) exists because:',
        choices: {
            a: 'for a valid (r, s), (r, n - s) is also valid',
            b: 'high-S signatures leak bits of the private key',
            c: 'high-S signatures fail on some hardware wallets',
            d: 'low-S values make batch verification possible',
        },
        answer: 'a',
        explanation: 'Without a canonical-S rule a signature is malleable. Requiring S in the lower half of the curve order removes that; Schnorr avoids it by design.',
    },
    {
        id: 99,
        difficulty: 'hard',
        question: 'A Lightning "penalty" (revocation) transaction lets a channel party:',
        choices: {
            a: 'claim the whole channel if the peer broadcasts a revoked state',
            b: 'reverse a Lightning payment that was routed to the wrong node by mistake',
            c: 'close the channel early and reclaim the funding fee',
            d: 'claim routing fees owed by a peer that went offline',
        },
        answer: 'a',
        explanation: 'Each new state revokes the previous one by handing over a per-state secret; broadcasting a stale state is punishable.',
    },
    {
        id: 100,
        difficulty: 'hard',
        question: 'Why must a Lightning node watch the chain (or delegate to a "watchtower") while a channel is open?',
        choices: {
            a: 'to catch a revoked state and punish it before the CSV delay ends',
            b: 'to keep channel balances in sync with on-chain fee rates',
            c: 'to re-sign every payment routed through it before its HTLC times out',
            d: 'to stop the channel closing when its funding output matures',
        },
        answer: 'a',
        explanation: 'The CSV delay on commitment outputs is the window in which fraud must be challenged.',
    },
];
